import * as moment from "moment";
import { auth, database } from "../firebase";

export const createNewSingleTemplate = async (details) => {
  try {
    let changedObject = details.details;
    changedObject.timestamp = moment().unix();
    changedObject.lastUpdated = moment().unix();
    changedObject.addedBy = auth.currentUser.uid;
    if (changedObject.title) {
      if (changedObject.type === "email") {
        delete changedObject.content;
        await database
          .collection("companies")
          .doc(details.companyId)
          .collection("templates")
          .add(changedObject);
        return { error: null, payload: "email" };
      } else {
        delete changedObject.messageData;
        await database
          .collection("companies")
          .doc(details.companyId)
          .collection("templates")
          .add(changedObject);
        return { error: null, payload: "sms" };
      }
    }
  } catch (e) {
    throw new Error(e);
  }
};
